import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_HeaderBank = _resolveComponent("HeaderBank")!
  const _component_WhyBank = _resolveComponent("WhyBank")!
  const _component_ArticlesGallery = _resolveComponent("ArticlesGallery")!
  const _component_Club = _resolveComponent("Club")!
  const _component_FooterBank = _resolveComponent("FooterBank")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar, { onMenu: _ctx.changeBack }, null, 8, ["onMenu"]),
    _createVNode(_component_HeaderBank, { opacit: _ctx.opacity }, null, 8, ["opacit"]),
    _createVNode(_component_WhyBank),
    _createVNode(_component_ArticlesGallery),
    _createVNode(_component_Club),
    _createVNode(_component_FooterBank)
  ]))
}